import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { painList } from '../../data/programa';
export function PainPoints() {
  return <section id="diagnostico" className="border-b border-line bg-carbon py-[60px] lg:py-[100px]" data-id="element-183" data-mp="27nc8gf5udbii">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-184" data-mp="22uj4hti7677h">
        <SectionHeading eyebrow="El diagnóstico" title={<span className="text-gold" data-id="element-186" data-mp="2hj6w5oox9ws5">
              ¿Cuántos lunes más vas a empezar ya fundido?
            </span>} description="No es falta de voluntad. Tu biología no fue diseñada para 8 horas frente a una pantalla — y nunca te dieron el manual." data-id="element-185" data-mp="2hkhzjnegh2iq" />

        <ul className="mx-auto mt-14 grid max-w-4xl gap-3 sm:grid-cols-2" data-id="element-187" data-mp="2mjl4l7ufr8qp">
          {painList.map((item, index) => <Reveal key={item} delay={index * 0.04} as="li" className="h-full" data-id="element-188" data-mp="w6voc8jce6pb" data-mpi={index}>
              <div className="flex h-full items-start gap-3 rounded-2xl border border-alert/40 bg-alert/10 px-5 py-4" data-id="element-189" data-mp="w8ynpj6dxc6p">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" strokeWidth={2.5} aria-hidden="true" data-id="element-190" data-mp="1n83e62t2g2lj" />
                <span className="text-[15px] leading-[1.6] text-ice" data-id="element-191" data-mp="1s6da4fmm7787">
                  {item}
                </span>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-192" data-mp="1x46csyoplj3q">
          <p className="mt-12 text-center text-2xl font-bold tracking-tight text-gold sm:text-3xl" data-id="element-193" data-mp="21x7t9b4kdqpf">
            ¿Y si este fuera el último lunes que empezás así?
          </p>
        </Reveal>
      </div>
    </section>;
}